import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "input", "submit", "selectAll", "select", "customReason"]

  connect() {
    this.checkboxTargets.forEach((checkbox) => {
      this.toggleRow({ target: checkbox })
    })
    this.validate()
  }

  toggleRow(event) {
    const row = event.target.closest("tr")
    const input = row.querySelector("input[type='number']")
    input.disabled = !event.target.checked
    if (!event.target.checked) input.value = 0
    this.validate()
  }

  handleReasonChange(event) {
    const select = event.target
    const rowIdx = select.dataset.rowIdx
    const customReasonField = this.customReasonTargets.find(field => field.dataset.rowIdx === rowIdx)

    if (customReasonField) {
      if (select.value === 'other') {
        customReasonField.style.display = 'block'
        customReasonField.required = true
      } else {
        customReasonField.style.display = 'none'
        customReasonField.required = false
        customReasonField.value = ''
      }
    }
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(cb => {
      cb.checked = checked
      this.toggleRow({ target: cb })
    })
  }

  validate() {
    let anySelected = false
    let allPositive = true

    this.checkboxTargets.forEach((cb, idx) => {
      if (cb.checked) {
        anySelected = true
        const qty = parseInt(this.inputTargets[idx].value, 10) || 0
        if (qty <= 0) allPositive = false
      }
    })

    const formOK = anySelected && allPositive
    if (this.hasSubmitTarget) this.submitTarget.disabled = !formOK
  }

  inputChanged() {
    this.validate()
  }
}
